<template>
  <ProSpaceGeoLayout
    class="address-program"
    :class="{ 'address-program--outlets-mode': isGroupingOutletsMode }"
    ref="address-program"
  >
    <template #top>
      <ProSpaceTopPanel
        class="address-program__top"
        :boxShadow="true"
        :back="isGroupingOutletsMode"
        @back="backToGroupingHandler"
        :header="getTitle()"
      >
        <template #center>
          <ProSpaceHLayout :gap="15" style="width: auto">
            <ProSpaceTag
              v-if="checkOrderStatusTag()"
              :type="statusTagType"
              :text="$t(`order_${order?.status}`)"
              is-border-style
            />
            <ProSpaceTag
              v-if="getBlockedPeriod"
              type="error"
              :text="$t('adjustmentsAreBlocked')"
              is-border-style
            />
          </ProSpaceHLayout>
        </template>
        <template #right>
          <ProSpaceIconButton
            icon="update"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="30px"
            @click="actionUpdate"
            v-if="!isGroupingOutletsMode"
          />
          <ProSpaceIconButton
            v-if="
              this.checkAccessItem('grid-headerButton-copy') &&
              currentPeriod.status === 'opened'
            "
            title="Скопировать параметры территории агентства из предыдущего периода"
            icon="document-copy"
            iconWidth="22px"
            iconHeight="22px"
            containerSize="30px"
            bordered
            @click="showCopyModal = true"
          />
          <ProSpaceButton
            style="padding-top: 4px; padding-bottom: 4px"
            icon="chevron-down"
            type="secondary"
            :label="currentPeriod?.name"
            @click="actionPeriod"
            :disabled="isGroupingOutletsMode"
          />
          <ProSpaceButton
            v-if="
              checkAccessItem('grid-headerButton-upload') &&
              !isGroupingOutletsMode &&
              currentPeriod.status === 'opened'
            "
            type="primary"
            icon="plus"
            :label="$t('upload')"
            @click="actionImport"
          />
          <ProSpaceButton
            v-if="showPublish"
            type="primary"
            icon="check"
            :label="$t('publishOrder')"
            class="address-program__green-button"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashPublishOrder'),
                text: $t('addressProgramTextFlashPublishOrder'),
                action: 'actionPublish',
              })
            "
          />
          <ProSpaceButton
            v-if="checkApprove()"
            type="primary"
            icon="check"
            :label="$t('approveOrder')"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashApproveOrder'),
                text: $t('addressProgramTextFlashApproveOrder'),
                action: 'actionApprove',
              })
            "
          />
          <ProSpaceButton
            v-if="checkConfirm()"
            type="primary"
            icon="check"
            :label="$t('confirmOrder')"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashConfirmOrder'),
                text: $t('addressProgramTextFlashConfirmOrder'),
                action: 'actionConfirm',
              })
            "
          />
          <ProSpaceDots
            :options="dotsHeaderOptions"
            :isSquare="true"
            @action="(action) => handleHeaderDots(action)"
          />
          <!--          <ProSpaceButton
            v-if="checkAccessItem('grid-headerButton-download')"
            type="secondary"
            icon="upload-cloud"
            :label="$t('downloadOrder')"
          />-->
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #left>
      <AddressProgramGroupingPanel
        ref="groupingPanel"
        :service="addressProgramOrderService"
        :isGroupingOutletsMode="isGroupingOutletsMode"
        :checkAccess="checkAccess"
        :selected="selectedGroups"
        :is-attemped-reset="isAttempedReset"
        @selectGroups="selectGroups"
      />
    </template>
    <template #center>
      <ProSpaceGeoLayout class="address-program__grid-container">
        <template #top>
          <ProSpaceFilterPanel
            :searchPlaceholder="$t('searchOnOutletId')"
            :modelFastFilter="modelFastFilter"
            :fastFilters="fastFilters"
            @apply="submitFilter"
            @update:modelFastFilter="updateModelFastFilter($event)"
            ref="filterPanel"
            filter-model="outletId"
            :txtResetFilters="$t('txtResetFilters')"
            :class="[
              'address-program__filters',
              { 'address-program__filters--disabled': isGroupingOutletsMode },
            ]"
            :noMountedRequest="true"
            :excludedFilters="['marsPeriodId', 'orderId']"
            :oneValueFilters="['marsPeriodId', 'orderId', 'orderStatus']"
            equalsSearch
            onlyDigit
            :chips="{
              onlyNumbers: true,
              lengthValue: 18,
            }"
            :unicKeyStorage="
              addressProgramOrderService.constructor.name + 'filter-panel'
            "
            :closeTxt="$t('closeTxt')"
            :txtChipsList="$t('txtChipsList')"
            :blocked-filters="!isGroupingGrid && needBlock"
            :thresholdShowMiniSearchButton="155"
            @block="selectedMultipleBlockFilterHandler"
            @block-chips="showModalBlockChips"
          >
            <template #hint>
              {{ $t("filterBy") }}
            </template>
            <template #filters="{ filter }">
              <div
                v-for="(searchField, index) in getFilterSearchFieldSettings"
                :key="`${searchField.model}-${index}`"
              >
                <ProSpaceFilterSearchfield
                  v-if="searchField.show"
                  v-model="filter[searchField.model]"
                  :service="searchField.service"
                  :get-method="searchField.getMethod"
                  :optionLabel="searchField.optionLabel"
                  :optionValue="searchField.optionValue"
                  :optionCode="searchField.optionCode"
                  :placeholder-value="searchField.placeholderValue"
                  :selectAllTxt="searchField.selectAllTxt"
                  :closeTxt="searchField.closeTxt"
                  :cancelTxt="searchField.cancelTxt"
                  :applyTxt="searchField.applyTxt"
                  :clearFilterTxt="searchField.clearFilterTxt"
                  :txtTitleModal="searchField.txtTitleModal"
                  :defaultFilter="searchField.defaultFilter"
                  @apply="(model) => customFilterApply(filter, model)"
                />
              </div>
              <ProSpaceCustomFilterPanel
                ref="customFilterRef"
                :need-mounted-apply="false"
                :customTxt="$t('custom')"
                :customFilterTxt="$t('customFilterTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :clearTxt="$t('clearTxt')"
                :applyTxt="$t('selectTxt2')"
                :clearFilterTxt="$t('clearTxt')"
                :fromTxt="$t('fromTxt')"
                :toTxt="$t('toTxt')"
                :closeTxt="$t('closeTxt')"
                :services="customServices"
                :unicKeyStorage="
                  addressProgramOrderService.constructor.name +
                  'custom-filter-panel'
                "
                :filterModalTitle="$t('customFilterTitle')"
                nameStorage="component_filter_panel"
                @apply="(model) => customFilterApply(filter, model)"
              />
              <ProSpaceMultiSelect
                ref="filterCoverage"
                :localization="$t"
                v-model="filter.coverage"
                :service="addressProgramOrderService"
                getMethod="gethasAdjustmentFilterTypes"
                optionLabel="text"
                optionValue="value"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :placeholderValue="$t('coverage')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearTxt')"
                @apply="(model) => customFilterApply(filter, model, true, true)"
              />
            </template>
          </ProSpaceFilterPanel>
        </template>
        <template #center>
          <ProSpaceMainGrid
            ref="grid"
            :service="addressProgramOrderService"
            :class="[
              `address-program__${
                !isGroupingGrid || isGroupingOutletsMode ? 'main' : 'grouping'
              }-grid`,
              `address-program__${
                gridSelectionMode !== 'multiple' ? 'single' : 'multiple'
              }-grid`,
            ]"
            @selected-change="selectedHandler"
            @db-click="toItem"
            getMethod="grid"
            :selectionMode="gridSelectionMode"
            :noMountedRequest="true"
            :defaultSortField="selectCurrentSorting"
            :loaderConfig="getLoaderConfig"
            :defaultColumnWidths="[138, 421, 230]"
            :autoWidthStatusId="false"
            :calcCustomViewCount="50"
            @update:total="setTotalRecords"
          >
            <template #columns>
              <template v-if="!isGroupingGrid || isGroupingOutletsMode">
                <Column
                  field="outletId"
                  :header="$t('addressProgramOutlet')"
                  sortable
                  class="address-program__column-store"
                  frozen
                >
                  <template #body="field">
                    <div class="address-program__column-store-container">
                      <store-column
                        v-if="field.data && !isGridRefreshing"
                        :data="field.data"
                        :status="getStatus(field.data.status)"
                        :isStatusDisplay="checkAccessItem('grid-orderStatus')"
                        :class="{
                          'store-column__single':
                            gridSelectionMode === 'single',
                        }"
                      />
                    </div>
                  </template>
                </Column>
                <Column
                  class="address-program__bordered-column address-program__sorting-table-header"
                  :field="
                    selectCurrentSorting === 'outletId'
                      ? getSortingOptions[0]?.value
                      : selectCurrentSorting
                  "
                  :header="`${$t('addressProgramParameters')} ${
                    currentSortingLabel ? '(' + currentSortingLabel + ')' : ''
                  }`"
                  sortable
                >
                  <template #header="field">
                    <ProSpaceDropdown
                      v-model="selectCurrentSorting"
                      class="address-program__dropdown"
                      :options="getSortingOptions"
                      :inputStyle="{ display: 'none' }"
                      propLabel="label"
                      propValue="value"
                      :dropdownIcon="[
                        'prospace-icon icon-sliders',
                        { 'prospace-icon--secondary': dropdownVisible },
                      ]"
                      filterIcon="icon-search prospace-icon"
                      :filterPlaceholder="$t('searchTxt')"
                      scrollHeight="245px"
                      filter
                      @hide="dropdownVisible = false"
                      @show="dropdownVisible = true"
                    >
                    </ProSpaceDropdown>
                  </template>
                  <template #body="field">
                    <multi-column
                      v-if="field.data && !isGridRefreshing"
                      :columns="6"
                      :data="getParamsColumns(field.data)"
                    />
                  </template>
                </Column>
                <Column
                  class="address-program__bordered-column no-right"
                  field="frequencyPlan"
                  :header="'KPI'"
                  sortable
                >
                  <template #body="field">
                    <multi-column
                      v-if="field.data && !isGridRefreshing"
                      :columns="3"
                      :data="getKpiColumns(field.data)"
                    />
                  </template>
                </Column>
                <Column
                  field="other"
                  class="address-program__column-store-amount frozen"
                  style="max-width: 40px; min-width: 40px"
                  frozen
                  alignFrozen="right"
                >
                  <template #body="field">
                    <div class="address-program__column-store-amount-container">
                      <ProSpaceDots
                        v-if="field.data && !isGridRefreshing"
                        :options="dotsWrapper(field.data)"
                        @action="(action) => handleDots(action, field.data)"
                      />
                    </div>
                  </template>
                </Column>
              </template>
              <template v-else-if="isGroupingGrid">
                <Column
                  class="address-program__bordered-column"
                  :field="selectCurrentSorting"
                  :header="$t('addressProgramParameters')"
                  sortable
                >
                  <template #body="field">
                    <multi-column
                      v-if="field.data && !isGridRefreshing"
                      :columns="6"
                      :data="getGroupingParams(field.data)"
                    />
                  </template>
                </Column>
                <Column
                  class="address-program__bordered-column"
                  field="frequencyPlan"
                  :header="'KPI'"
                  sortable
                >
                  <template #body="field">
                    <multi-column
                      v-if="field.data && !isGridRefreshing"
                      :columns="3"
                      :data="getKpiColumns(field.data)"
                    />
                  </template>
                </Column>
                <Column
                  field="storeAmount"
                  :header="$t('numberOfOutlets')"
                  sortable
                  class="address-program__column-store-amount"
                  style="min-width: 110px;"
                >
                  <template #body="field">
                    <div class="address-program__column-store-amount-container">
                      <div
                        v-if="field.data && field.data.outletCount"
                        :class="['address-program__store-counter']"
                      >
                        {{ field.data.outletCount }}
                      </div>
                      <ProSpaceDots
                        v-if="field.data && !isGridRefreshing"
                        :options="dotsOptions"
                        @action="(action) => handleDots(action, field.data)"
                      />
                    </div>
                  </template>
                </Column>
              </template>
            </template>
            <template #empty>
              <ProSpaceEmptyGrid
                icon="error-message"
                :title="$t('noDataTitle')"
                :text="$t('noDataTxt')"
              />
            </template>
          </ProSpaceMainGrid>
        </template>
      </ProSpaceGeoLayout>
      <AddressProgramOrderModalImport
        v-model="showImportModal"
        @loading="loadingHandler"
        accept=".xlsx"
        :checkAccess="checkAccess"
      />
      <ProSpaceHistoryModal
        ref="history"
        v-model="showHistoryModal"
        modelName="AddressProgramOrderArchivedApiModel"
        @close="closeHistory"
      />
    </template>
    <template #right>
      <AddressProgramOrderPanel
        v-if="hasSelect"
        class="address-program__order-panel"
        ref="right-panel"
        :options="dotsOptions"
        :is-grouping-grid="isGroupingGrid"
        :is-grouping-outlets-mode="isGroupingOutletsMode"
        :hide-request="!canAdjustmentRequest"
        :checkAccess="checkAccess"
        :dotsWrapper="dotsWrapper"
        :is-user-has-agency="isUserHasAgency"
        :is-user-has-agency-role="isUserHasAgencyRole"
        :currentPeriod="currentPeriod"
        :is-all-rows-selected="isAllRowsSelected || isAllSelectedCount"
        @showAgencyTerritoryModal="showAgencyTerritoryModalHandler"
        @open="() => toItem(selectedData)"
        @clear="selectedMultipleReset"
        @clear:excluded="selectedMultipleReset"
        @edit="editItem"
        @delete="deleteItem"
        @history="showHistory"
        @adjustment="adjustmentRequestHandler"
        @openOutletsList="() => toItem(selectedData)"
      />
    </template>
    <template #bottom>
      <AddressProgramOrderFooter
        :store-amount="summary?.outletCount"
        :budget="summary?.totalSumPlan"
        :formatter="formatDigit"
      />
    </template>
  </ProSpaceGeoLayout>
  <ProSpaceFlashMessage
    v-if="showCopyModal"
    v-model="showCopyModal"
    :applyTxt="$t('confirmTxt')"
    :cancelTxt="$t('cancelTxt')"
    :title="$t('addressProgramCopyTitle')"
    @apply="actionCopy"
    :loading="isDataCopying"
    :needHideApply="false"
  >
    <span
      v-html="
        $t('addressProgramCopyContent', [
          $t('kAS'),
          $t('merchandisers', 2),
          $t('routeCodes', 2),
        ])
      "
    />
  </ProSpaceFlashMessage>
  <ProSpaceFlashMessage
    v-model="showClearModal"
    :applyTxt="$t('confirmTxt')"
    :cancelTxt="$t('cancelTxt')"
    :title="$t('questClearFilters')"
    @apply="actionClear"
    @cancel="actionCancelClear"
    :needHideApply="false"
  >
    {{ $t("bodyClearFilters") }}
  </ProSpaceFlashMessage>
  <ProSpaceFlashMessage
    v-model="showBlockChips"
    :cancelTxt="$t('cancelTxt')"
    :title="$t('blockChipsTitle')"
    @cancel="onCancel"
    :needHideApply="true"
  >
    {{ $t("blockChipsBody") }}
  </ProSpaceFlashMessage>
  <ProSpaceFlashMessage
    v-model="showBlockAdjustmentsModal"
    :cancelTxt="$t('closeTxt')"
    :title="$t('adjustmentsAreBlocked')"
    icon="flash-warning"
    @cancel="showBlockAdjustmentsModal = false"
  >
    {{ $t("adjustmentAreBlockedTextInfo") }}
  </ProSpaceFlashMessage>
  <ProSpaceFlashMessage
    v-model="confirmationOrdersModalState.show"
    :cancelTxt="$t('cancelTxt')"
    :title="confirmationOrdersModalState.title"
    :needHideApply="false"
    :applyTxt="$t('confirmTxt')"
    icon="flash-warning"
    @apply="confirmationOrdersModalAction(confirmationOrdersModalState.action)"
    @cancel="confirmationOrdersModalState.show = false"
  >
    {{ confirmationOrdersModalState.text }}
  </ProSpaceFlashMessage>
  <AgencyTerritoryModal
    v-if="showAgencyTerritoryModal"
    v-model="showAgencyTerritoryModal"
    :kas-service="kASService"
    :merchandiser-service="merchandiserService"
    :route-code-service="routeCodeService"
    @agencyTerritoryEdit="agencyTerritoryEdit"
    :isDataLoading="isTerritoryEditLoading"
    :needHideApply="false"
  />
  <ModalBlockFilters />
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceIconButton,
  ProSpaceIcon,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
  ProSpaceEmptyGrid,
  ProSpaceTree,
  ProSpaceHLayout,
  ProSpaceFilterContainsChips,
  ProSpaceFilterDatesRange,
  ProSpaceDropdown,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceInputSwitch,
  ProSpaceInputText,
  ProSpaceTag,
  ProSpaceFilterSwitch,
  ProSpaceFilterSearchfield,
  ProSpaceFilterCheckbox,
  ProSpaceFlashMessage,
} from "@prospace/prospace-components-library";
import { AddressProgramOrderService } from "../../services/AddressProgramOrderService.js";
import { RSMService } from "../../services/RSMService.js";
import { MarsPeriodService } from "../../services/MarsPeriodService.js";
import { TDMService } from "../../services/TDMService.js";
import { KAEService } from "../../services/KAEService.js";
import { AgencyService } from "../../services/AgencyService.js";
import { NetworkService } from "../../services/NetworkService.js";
import { ExternalFormatService } from "../../services/ExternalFormatService.js";
import { OutletTypeService } from "../../services/OutletTypeService.js";
import { ChannelService } from "../../services/ChannelService.js";
import { ClusterService } from "../../services/ClusterService.js";
import { NARKAService } from "../../services/NARKAService.js";
import { SIPChannelService } from "../../services/SIPChannelService.js";
import { KASService } from "../../services/KASService.js";
import { MerchandiserService } from "../../services/MerchandiserService.js";
import { RouteCodeService } from "../../services/RouteCodeService.js";
import { OrderStatusService } from "../../services/OrderStatusService";
import { StatusService } from "../../services/StatusService";
import { OrderService } from "../../services/OrderService";

import Column from "primevue/column";
import AddressProgramOrderPanel from "./components/AddressProgramOrderPanel";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal.vue";
import AddressProgramOrderModalImport from "./components/AddressProgramOrderModalImport";
const _ = require("lodash");
import { mapGetters } from "vuex";
import AddressProgramOrderFooter from "./components/AddressProgramOderFooter.vue";
import StoreColumn from "./columns/storeColumn.vue";
import MultiColumn from "./columns/multiColumn.vue";
import AddressProgramGroupingPanel from "./components/grouping/AddressProgramGroupingPanel.vue";
import marsPeriod from "../MarsPeriods/MarsPeriod.vue";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import { queryBuilder } from "@prospace/prospace-components-library";
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";
import sortingOptions from "./sortingOptions";
import AgencyTerritoryModal from "./components/AgencyTerritoryModal.vue";
import { useMultiSelectGrid } from "@composes/multiselect";
import { ref } from "vue";
import ModalBlockFilters from "@multiselect/ModalBlockFilters";
import Skeleton from "primevue/skeleton";
export default {
  mixins: [accessMixin],
  components: {
    AgencyTerritoryModal,
    StoreColumn,
    MultiColumn,
    AddressProgramOrderFooter,
    AddressProgramOrderPanel,
    AddressProgramOrderModalImport,
    AddressProgramGroupingPanel,
    ProSpaceFilterPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceModal,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceIconButton,
    ProSpaceIcon,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
    ProSpaceEmptyGrid,
    ProSpaceHistoryModal,
    ProSpaceTree,
    ProSpaceHLayout,
    ProSpaceFilterContainsChips,
    ProSpaceFilterDatesRange,
    ProSpaceDropdown,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceInputSwitch,
    ProSpaceInputText,
    ProSpaceTag,
    ProSpaceFilterSwitch,
    ProSpaceFilterSearchfield,
    ProSpaceFilterCheckbox,
    ProSpaceFlashMessage,
    ModalBlockFilters,
  },
  setup() {
    const grid = ref(null);
    const filterPanel = ref(null);
    const customFilterRef = ref(null);
    const {
      selectedMultipleGridHandler,
      selectedMultipleClear,
      selectedClude,
      selectedData,
      selectedCount,
      hasSelect,
      selectedMultipleBlockFilterHandler,
      needBlock,
      getRequestModel,
      selectedMultipleReset,
    } = useMultiSelectGrid(grid, filterPanel, customFilterRef);
    return {
      grid,
      filterPanel,
      customFilterRef,
      selectedMultipleGridHandler,
      selectedData,
      selectedClude,
      hasSelect,
      selectedMultipleClear,
      selectedMultipleBlockFilterHandler,
      needBlock,
      selectedCount,
      getRequestModel,
      selectedMultipleReset,
    };
  },
  data() {
    return {
      queryBuilder,
      isGroupingOutletsMode: false,
      selectedGroups: [],
      oldFilters: {},
      showModal: false,
      showImportModal: false,
      showHistoryModal: false,
      // Grid Panel
      showClearModal: false,
      isAllRowsSelected: false,
      isAttempedReset: false,

      // Service
      addressProgramOrderService: new AddressProgramOrderService(),
      addressProgramOrderServiceSummary: new AddressProgramOrderService(),
      rSMService: new RSMService(),
      tDMService: new TDMService(),
      kAEService: new KAEService(),
      agencyService: new AgencyService(),
      networkService: new NetworkService(),
      externalFormatService: new ExternalFormatService(),
      outletTypeService: new OutletTypeService(),
      channelService: new ChannelService(),
      clusterService: new ClusterService(),
      nARKAService: new NARKAService(),
      sIPChannelService: new SIPChannelService(),
      kASService: new KASService(),
      merchandiserService: new MerchandiserService(),
      routeCodeService: new RouteCodeService(),
      marsPeriodService: new MarsPeriodService(),
      orderStatusService: new OrderStatusService(),
      statusService: new StatusService(),
      orderService: new OrderService(),

      //InlinePanel
      isEdit: false,
      isCreate: false,
      modalModel: {},

      // Multi filter
      // modelFastFilter: {
      //   value: []
      // },
      order: null,
      canPublish: false,
      canClose: false,
      selectCurrentSorting: "outletId",
      dropdownVisible: false,
      currentSortingLabel: this.$t("rsm"),
      sortingOptions: sortingOptions(this.$t),
      paramsFilters: {
        status: null,
      },
      filterOrderId: null,
      // fastFilters: null,
      summary: null,
      addressProgramFilter: "",
      orderStatus: "",
      filterCoverage: true,
      statusTagType: null,

      ro: null,
      breakpoint: null,

      showCopyModal: false,
      notBy: null,
      agencyTerritoryModalModel: {},
      showAgencyTerritoryModal: false,
      selectedForTerritoryEdit: {},
      isTerritoryEditLoading: false,
      isDataCopying: false,
      dotsHeaderOptions: [
        { name: "export_xlsx", text: this.$t("export_xlsx"), icon: "download" },
      ],
      showBlockChips: false,
      showBlockAdjustmentsModal: false,
      confirmationOrdersModalState: {
        show: false,
      },
      totalRecords: null,
      showAgencyIdFilterSearchFiled: false,
      accessList: [
        { name: "agencyId-ProSpaceFilterSearchfield", value: false },
        { name: "agencyValue-row", value: false },
        { name: "agencyTerritory-row", value: false },
        { name: "grid-headertag-orderStatus", value: false },
        { name: "grid-headerButton-approve", value: false },
        { name: "grid-headerButton-confirm", value: false },
        { name: "grid-headerButton-openPeriod", value: false },
        { name: "request-checkPublish", value: false },
        { name: "grid-headerButton-copy", value: false },
        { name: "grid-headerButton-upload", value: false },
        { name: "grid-orderStatus", value: false },
        { name: "grid-selectionModeCheckboxes", value: false },
        { name: "rightPanel-action-adjustmentRequest", value: false },
        { name: "grid-headerButton-publish", value: false },
      ],
    };
  },
  watch: {
    currentPeriod: {
      handler: function (val, oldVal) {
        if (Object.keys(val).length > 0) {
          if (val?.id !== oldVal?.id) {
            this.initHandler();
          }
        }
      },
      immediate: true,
    },
    selectCurrentSorting(val) {
      const option = this.getSortingOptions.find((s) => s.value === val);
      if (option) {
        this.currentSortingLabel = option.label;
      }
      this.dropdownVisible = false;
      this.$nextTick(() => {
        this.grid.getRecords(true);
        this.addressProgramFilter = this.grid.getRecords(true, true);
        this.loadingHandler(true);
      });
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      access: "securityRoleAccess/access",
      currentPeriod: "marsPeriodStoreArchived/getMarsPeriod",
    }),
    isGridRefreshing() {
      return this.grid.isRefreshing;
    },
    isUserHasAgency() {
      let roleModelSystemName = JSON.parse(
        localStorage.getItem("userRole")
      ).systemName;
      return (
        this.userinfo.agencyLinkType === "AGENCY" &&
        (roleModelSystemName === "AgencyAdministrator" ||
          roleModelSystemName === "AgencySupervisor")
      );
    },
    isUserHasAgencyRole() {
      let roleModelSystemName = JSON.parse(
        localStorage.getItem("userRole")
      ).systemName;
      return (
        roleModelSystemName === "AgencyAdministrator" ||
        roleModelSystemName === "AgencySupervisor"
      );
    },
    fastFilters() {
      if (this.isUserHasAgency) {
        if (this.order?.id) {
          return [
            {
              label: this.$t("allTxt"),
              value: [
                { field: "disabled", value: false },
                { field: "marsPeriodId", value: this.currentPeriod?.id },
                { field: "orderId", value: this.filterOrderId },
              ],
            },
            {
              label: this.$t("notByKas"),
              value: [
                { field: "kasValue", value: null },
                { field: "disabled", value: false },
                { field: "marsPeriodId", value: this.currentPeriod?.id },
                { field: "orderId", value: this.filterOrderId },
              ],
            },
            {
              label: this.$t("notByMerchs"),
              value: [
                { field: "merchandiserValue", value: null },
                { field: "disabled", value: false },
                { field: "marsPeriodId", value: this.currentPeriod?.id },
                { field: "orderId", value: this.filterOrderId },
              ],
            },
          ];
        } else {
          return [
            {
              label: this.$t("allTxt"),
              value: [
                { field: "disabled", value: false },
                { field: "marsPeriodId", value: this.currentPeriod?.id },
                { field: "orderId", value: 0 },
              ],
            },
          ];
        }
      } else {
        return [
          {
            label: this.$t("allTxt"),
            value: [
              { field: "disabled", value: false },
              { field: "marsPeriodId", value: this.currentPeriod?.id },
            ],
          },
          {
            label: this.$t("ordercreated"),
            value: [
              { field: "orderStatus", value: "created" },
              { field: "disabled", value: false },
              { field: "marsPeriodId", value: this.currentPeriod?.id },
            ],
          },
          {
            label: this.$t("orderpublished"),
            value: [
              { field: "orderStatus", value: "published" },
              { field: "disabled", value: false },
              { field: "marsPeriodId", value: this.currentPeriod?.id },
            ],
          },
          {
            label: this.$t("orderapproved"),
            value: [
              { field: "orderStatus", value: "approved" },
              { field: "disabled", value: false },
              { field: "marsPeriodId", value: this.currentPeriod?.id },
            ],
          },
          {
            label: this.$t("ordercompleted"),
            value: [
              { field: "orderStatus", value: "completed" },
              { field: "disabled", value: false },
              { field: "marsPeriodId", value: this.currentPeriod?.id },
            ],
          },
        ];
      }
    },
    modelFastFilter: {
      get() {
        if (this.order?.id) {
          if (this.notBy) {
            return this.fastFilters.find((f) =>
              f.value.find((s) => s.field === this.notBy)
            );
          } else {
            return this.fastFilters[0];
          }
        } else {
          if (this.orderStatus) {
            return this.fastFilters.find((f) =>
              f.value.find((s) => s.value === this.orderStatus)
            );
          } else {
            return this.fastFilters[0];
          }
        }
      },
    },
    gridSelectionMode() {
      if (this.isGroupingGrid && !this.isGroupingOutletsMode) return "single";
      return this.checkAccessItem("grid-selectionModeCheckboxes")
        ? "multiple"
        : "single";
    },
    customServices() {
      const getFilter = (field, value) => {
        if (value) {
          if (field === "status") {
            return {
              [field]: {
                or: [value],
              },
            };
          } else {
            return {
              [field]: {
                and: [value],
              },
            };
          }
        }
        return {};
      };
      return [
        [
          {
            service: new KAEService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            type: "search-field",
            model: "kAEId",
            label: this.$t("kae"),
            selected: {},
            defaultCollapsed: true,
            txtTitleModal: this.$t("kaeList"),
          },
          {
            service: new KASService(),
            getMethod: "grid",
            optionValue: "value",
            optionLabel: "value",
            type: "search-field",
            model: "kASValue",
            label: this.$t("kAS"),
            selected: {},
            defaultCollapsed: true,
            txtTitleModal: this.$t("kasList"),
          },
          {
            service: new MerchandiserService(),
            getMethod: "grid",
            optionValue: "value",
            optionLabel: "value",
            optionCode: "code",
            type: "search-field",
            model: "merchandiserValue",
            label: this.$t("merchandiser"),
            txtTitleModal: this.$t("merchList"),
            txtNameColumn: this.$t("merchandiserValue"),
            additionalColumns: [
              {
                title: this.$t("agency"),
                value: "agencyValue",
              },
            ],
            selected: {},
            defaultCollapsed: true,
          },
          {
            type: "search-field",
            model: "channelId",
            label: this.$t("channel"),
            service: new ChannelService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            selected: {},
            defaultCollapsed: false,
            txtTitleModal: this.$t("channelList"),
          },
          {
            type: "search-field",
            model: "nARKAId",
            label: this.$t("nARKA"),
            service: new NARKAService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            selected: {},
            defaultCollapsed: false,
            txtTitleModal: this.$t("narkaList"),
          },
          {
            service: new StatusService(),
            type: "checkboxes",
            model: "status",
            getMethod: "get",
            optionValue: "status",
            optionLabel: "text",
            label: this.$t("status"),
            placeholder: this.$t("status"),
            needSelectAll: true,
            selected: this.paramsFilters.status
              ? getFilter("status", this.paramsFilters.status)
              : {},
          },
          {
            type: "chips",
            model: "networkCode",
            label: this.$t("networkCode"),
            selected: {},
            allowDuplicate: false,
            placeholder: this.$t("networkCode"),
          },
          {
            type: "chips",
            model: "area",
            label: this.$t("area"),
            selected: {},
            allowDuplicate: false,
            placeholder: this.$t("area"),
          },
          {
            type: "chips",
            model: "city",
            label: this.$t("city"),
            selected: {},
            allowDuplicate: false,
            placeholder: this.$t("city"),
          },
          {
            type: "chips",
            model: "address",
            label: this.$t("address"),
            selected: {},
            allowDuplicate: false,
            placeholder: this.$t("address"),
          },
          {
            type: "checkboxes",
            service: new AddressProgramOrderService(),
            model: "hasAdjustments",
            getMethod: "gethasAdjustmentFilterTypes",
            optionLabel: "text",
            optionValue: "value",
            needSelectAll: true,
            label: this.$t("hasAdjustments"),
            selected: {},
          },
          {
            type: "checkboxes",
            service: new AddressProgramOrderService(),
            model: "updated",
            getMethod: "gethasAdjustmentFilterTypes",
            optionLabel: "text",
            optionValue: "value",
            needSelectAll: true,
            label: this.$t("updated"),
            selected: {},
          },
          {
            type: "dates-range-time",
            model: "updateDate",
            label: this.$t("updatedDate"),
            labelTo: this.$t("updatedDateTo"),
            labelFrom: this.$t("updatedDateFrom"),
            selected: {},
          },
          {
            type: "dates-range-time",
            model: "editDate",
            label: this.$t("changedDate"),
            labelTo: this.$t("changedDateTo"),
            labelFrom: this.$t("changedDateFrom"),
            selected: {},
          },
        ],
        [
          {
            type: "chips",
            model: "territoryCluster",
            label: this.$t("territoryCluster"),
            selected: {},
            onlyNumbers: true,
            allowDuplicate: false,
            placeholder: this.$t("territoryCluster"),
          },
          {
            type: "search-field",
            model: "clusterId",
            label: this.$t("geoCluster"),
            service: new ClusterService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            selected: {},
            txtTitleModal: this.$t("geoClusterList"),
          },
          {
            type: "chips",
            model: "tariffZone",
            label: this.$t("tariffZone"),
            selected: {},
            onlyNumbers: true,
            allowDuplicate: false,
            placeholder: this.$t("tariffZone"),
          },
          {
            type: "chips",
            model: "skyline",
            label: this.$t("skyline"),
            selected: {},
            onlyNumbers: true,
            allowDuplicate: false,
            placeholder: this.$t("skyline"),
          },
          {
            type: "chips",
            model: "externalCode",
            label: this.$t("externalCode"),
            selected: {},
            allowDuplicate: false,
            placeholder: this.$t("externalCode"),
          },
          {
            type: "chips",
            model: "outletId",
            label: this.$t("storeCode"),
            selected: {},
            onlyNumbers: true,
            allowDuplicate: false,
            placeholder: this.$t("storeCode"),
          },
          {
            type: "search-field",
            model: "outletTypeId",
            label: this.$t("outletType"),
            service: new OutletTypeService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            selected: {},
            txtTitleModal: this.$t("outletTypeList"),
          },
          {
            type: "search-field",
            model: "externalFormatId",
            label: this.$t("externalFormat"),
            service: new ExternalFormatService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            selected: {},
            txtTitleModal: this.$t("externalFormatList"),
          },
          {
            type: "search-field",
            model: "sIPChannelId",
            label: this.$t("sIPChannel"),
            service: new SIPChannelService(),
            getMethod: "grid",
            optionValue: "id",
            optionLabel: "value",
            selected: {},
            txtTitleModal: this.$t("sipChannelList"),
          },
          {
            type: "search-field",
            model: "routeCodeValue",
            label: this.$t("routeCode"),
            service: new RouteCodeService(),
            getMethod: "grid",
            optionValue: "value",
            optionLabel: "value",
            selected: {},
            dataType: "string",
            txtTitleModal: this.$t("routeCodeList"),
          },
          {
            type: "range",
            model: "fTEMerchPlan",
            label: this.$t("fTECountNorm"),
            selected: {},
            isFloatNumber: true,
            max: 999999,
          },
          {
            type: "range",
            model: "TimingPerVisitPlan",
            label: this.$t("timingPerVisitNorm"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "ratePerHourPlan",
            label: this.$t("ratePerHour"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "frequencyPlan",
            label: this.$t("visitSumPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "frequencyFact",
            label: this.$t("visitSumFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "oSAPlan",
            label: this.$t("oSAPlan"),
            selected: {},
            withPercentage: true,
            isFloatNumber: true,
            max: 999,
          },
          {
            type: "range",
            model: "oSAFact",
            label: this.$t("oSAFact"),
            selected: {},
            withPercentage: true,
            isFloatNumber: true,
            max: 999,
          },
          {
            type: "range",
            model: "deltaISAOSAPlan",
            label: this.$t("ISAOSAPlan"),
            selected: {},
            withPercentage: true,
            isFloatNumber: true,
            max: 999,
          },
        ],
        [
          {
            type: "range",
            model: "deltaISAOSAFact",
            label: this.$t("ISAOSAFact"),
            selected: {},
            withPercentage: true,
            isFloatNumber: true,
            max: 999,
          },
          {
            type: "range",
            model: "pSSPlan",
            label: this.$t("pSSPlan"),
            selected: {},
            withPercentage: true,
            isFloatNumber: true,
            max: 999,
          },
          {
            type: "range",
            model: "pSSFact",
            label: this.$t("pSSFact"),
            selected: {},
            withPercentage: true,
            isFloatNumber: true,
            max: 999,
          },
          {
            type: "range",
            model: "tacticalTaskPlan",
            label: this.$t("tacticalTaskPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "tacticalTaskFact",
            label: this.$t("tacticalTaskFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "visitBudgetsPlan",
            label: this.$t("visitBudgetsPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "visitSumFact",
            label: this.$t("visitBudgetsFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "oSASumPlan",
            label: this.$t("oSABudgPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "oSASumFact",
            label: this.$t("oSABudgFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "deltaISAOSASumPlan",
            label: this.$t("ISAOSABudgPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "deltaISAOSASumFact",
            label: this.$t("ISAOSABudgFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "pSSSumPlan",
            label: this.$t("pSSBudgPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "pSSSumFact",
            label: this.$t("pSSBudgFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "tacticalTaskSumPlan",
            label: this.$t("tacticalTaskBudgPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "tacticalTaskSumFact",
            label: this.$t("tacticalTaskBudgFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "totalSumPlan",
            label: this.$t("budgetSumPlan"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
          {
            type: "range",
            model: "totalSumFact",
            label: this.$t("budgetSumFact"),
            selected: {},
            isFloatNumber: true,
            max: 99999999,
          },
        ],
        //TODO: Вёрстка 4 колонок для общего фильтра. Поправить локализацию кноки Close при выборе диапазона дат
        // [
        // {
        //     type: "dates-range",
        //     model: "editDate",
        //     label: this.$t("changed"),
        //     selected: {}
        //   },
        //   {
        //     type: "dates-range",
        //     model: "updateDate",
        //     label: this.$t("updated"),
        //     selected: {}
        //   }
        // ]
      ];
    },
    dotsOptions() {
      let res = [];

      if (this.isUserHasAgency && this.currentPeriod.status === "closed") {
      } else {
        res.push({
          name: "open",
          text: this.$t("open"),
          icon: "file-lines",
          method: this.toItem,
          iconSize: "20px",
          order: 0,
        });
      }

      if (!this.isGroupingGrid) {
        res.push({
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showHistory,
          iconSize: "20px",
          order: 3,
        });
      }

      if (
        this.isUserHasAgencyRole &&
        this.currentPeriod.status != "closed" &&
        (!this.isGroupingGrid || this.isGroupingOutletsMode)
      )
        res.push({
          name: "showAgencyTerritory",
          text: this.$t("setAgencyTerritoryParams"),
          icon: "clone",
          iconSize: "16px",
          method: this.showAgencyTerritoryModalHandler,
          iconGap: 7,
          order: 2,
        });

      return res.sort((a, b) => a.order - b.order);
    },
    gridData() {
      return this.addressProgramOrderService.transformer.gridData;
    },
    isGroupingGrid() {
      return this.selectedGroups.length;
    },
    canAdjustmentRequest() {
      return (
        (!this.isGroupingGrid || this.isGroupingOutletsMode) &&
        this.checkAccessItem("rightPanel-action-adjustmentRequest")
      );
    },
    showPublish() {
      return (
        this.checkAccessItem("grid-headerButton-publish") && this.canPublish
      );
    },
    canSortByAgency() {
      return this.checkAccessItem("agencyValue-row"); // replace by grid-sorting-by-agency
    },
    getSortingOptions() {
      if (!this.canSortByAgency) {
        return this.sortingOptions.filter((s) => s.value !== "agencyId");
      } else {
        return this.sortingOptions;
      }
    },
    isAllSelectedCount() {
      return isNaN(this.selectedCount);
    },
    getBlockedPeriod() {
      return this.currentPeriod?.isBlocked;
    },
    getLoaderConfig() {
      return {
        cols: [15, 65, 35],
        rows: [
          { width: 100, height: 45, borderRadius: "5px" },
          { width: 100, height: 45, borderRadius: "5px" },
          { width: 100, height: 45, borderRadius: "5px" },
        ],
      };
    },
    getSingleLoaderConfig() {
      return {
        cols: [100],
        rows: [
          { width: 100, height: 45, borderRadius: "5px" },
          { width: 100, height: 45, borderRadius: "5px" },
          { width: 100, height: 45, borderRadius: "5px" },
        ],
      };
    },
    getFilterSearchFieldSettings() {
      return [
        {
          show: true,
          model: "rSMId",
          service: this.rSMService,
          placeholderValue: this.$t("rsm"),
          closeTxt: this.$t("closeTxt"),
          cancelTxt: this.$t("cancelTxt"),
          applyTxt: this.$t("selectTxt2"),
          clearFilterTxt: this.$t("clearTxt"),
          txtTitleModal: this.$t("rsm"),
          getMethod: "grid",
          optionLabel: "value",
          optionValue: "id",
          optionCode: "code",
        },
        {
          show: true,
          model: "tDMId",
          service: this.tDMService,
          placeholderValue: this.$t("tdm"),
          selectAllTxt: this.$t("selectAllTxt"),
          closeTxt: this.$t("closeTxt"),
          cancelTxt: this.$t("cancelTxt"),
          applyTxt: this.$t("selectTxt2"),
          clearFilterTxt: this.$t("clearTxt"),
          txtTitleModal: this.$t("tdm"),
          getMethod: "grid",
          optionLabel: "value",
          optionValue: "id",
          optionCode: "code",
          defaultFilter: { disabled: false },
        },
        {
          show: this.checkAccessItem("agencyId-ProSpaceFilterSearchfield"),
          model: "agencyId",
          service: this.agencyService,
          placeholderValue: this.$t("agency"),
          selectAllTxt: this.$t("selectAllTxt"),
          closeTxt: this.$t("closeTxt"),
          cancelTxt: this.$t("cancelTxt"),
          applyTxt: this.$t("selectTxt2"),
          clearFilterTxt: this.$t("clearTxt"),
          txtTitleModal: this.$t("agencyList"),
          getMethod: "grid",
          optionLabel: "value",
          optionValue: "id",
          optionCode: "code",
          defaultFilter: { disabled: false },
        },
        {
          show: true,
          model: "networkId",
          service: this.networkService,
          placeholderValue: this.$t("network"),
          selectAllTxt: this.$t("selectAllTxt"),
          closeTxt: this.$t("closeTxt"),
          cancelTxt: this.$t("cancelTxt"),
          applyTxt: this.$t("selectTxt2"),
          clearFilterTxt: this.$t("clearTxt"),
          txtTitleModal: this.$t("networkList"),
          getMethod: "grid",
          optionLabel: "value",
          optionValue: "id",
          optionCode: "code",
          defaultFilter: { disabled: false },
        },
      ];
    },
  },
  methods: {
    showModalBlockChips() {
      this.showBlockChips = true;
    },
    hideModalBlockChips() {
      this.showBlockChips = false;
    },
    formatDigit,
    checkIsAllRowsSelected() {
      this.$nextTick(() => {
        this.isAllRowsSelected = this.grid.isAllRowsSelected;
      });
    },
    handlerBlockFilterPanel({ tab }, evt) {
      this.showClearModal = true;
      this.actionClear = () => {
        this.selectedMultipleClear();
        if (tab) {
          this.filterPanel.fastFilter = tab;
        }
        this.$nextTick(() => {
          if (evt) {
            evt();
          } else {
            this.filterPanel.submitFilter();
          }
          this.showClearModal = false;
        });
      };
      this.actionCancelClear = () => {
        this.showClearModal = false;
      };
    },
    async initHandler() {
      this.loadOrder().then((res) => {
        if (res?.data?.data) {
          this.order = res?.data?.data;
          this.filterOrderId = this.order?.id;
          this.$nextTick(() => {
            this.emitFilter();
          });
        } else {
          this.order = null;
          this.filterOrderId = null;
          this.selectedModel = null;
          this.summary = {};
          this.$nextTick(() => {
            this.$refs["grid"].setRecords([]);
            this.emitFilter();
          });
        }
      });
      if (this.userinfo.agencyLinkType !== "AGENCY") {
        this.$nextTick(() => {
          this.emitFilter();
        });
      }
      this.selectedMultipleClear();
    },
    updateModelFastFilter(tab) {
      this.orderStatus = tab.value.find(
        (f) => f.field === "orderStatus"
      )?.value;
      this.modelFastFilter = tab;
    },
    handlerRouteParams() {
      const params = this.$route.params;
      if (params.groups) {
        this.addressProgramOrderService.setGroups(params.groups);
        this.selectedGroups = params.groups;
      }
      if (params.orderStatus) {
        this.orderStatus = params.orderStatus;
      }
      if (params.notBy) {
        this.notBy = params.notBy;
      }
    },
    backToGroupingHandler() {
      const wrappedFunction = () => {
        if (this.selectedClude?.items?.length) {
          this.selectedClude.items = [];
          this.selectedCount = 0;
        }
        this.filterPanel.filter = this.oldFilters;
        this.grid.filter = this.oldFilters;
        this.isGroupingOutletsMode = false;
        this.$refs.groupingPanel.collapsePanel();
        this.selectGroups(this.selectedGroups);
      };
      if (
        !this.grid.clickedItem &&
        (this.selectedClude?.isAll || this.selectedClude?.items.length)
      ) {
        this.handlerBlockFilterPanel({}, wrappedFunction);
        return;
      }
      wrappedFunction();
    },
    selectGroups(groups) {
      const wrappedFunction = async () => {
        this.addressProgramOrderService.setGroups(groups);
        if (groups?.length === 0) {
          this.grid.sortField = this.selectCurrentSorting;
          this.grid.skip = 0;
          this.selectedMultipleClear();
        }
        this.grid.records = [];
        await this.grid.getRecords();
        this.selectedGroups = groups;
        this.selectedCount = 0;
        this.selectedClude = {
          isAll: false,
          items: [],
        };
        this.grid.isAllRowsSelected = false;
        this.selectedModel = null;
        this.selectedClude = null;
        this.isAttempedReset = false;
        this.isAttempedReset = false;
        this.grid.clickedItem = null;
        this.selectedData = null;
      };
      if (
        !this.grid.clickedItem &&
        (this.selectedClude?.isAll || this.selectedClude?.items.length)
      ) {
        this.isAttempedReset = true;
        this.handlerBlockFilterPanel({}, wrappedFunction);
        return;
      }
      wrappedFunction();
    },
    editItem() {},
    deleteItem() {},
    getParamsColumns(data) {
      const {
        city,
        area,
        clusterValue,
        rsmValue,
        tdmValue,
        kaeValue,
        outletTypeValue,
        externalFormatValue,
        channelValue,
        narkaValue,
        sipChannelValue,
        externalCode,
        territoryCluster,
        tariffZone,
        skyline,
        agencyValue,
        coverage,
        kasValue,
        routeCodeValue,
        merchandiserValue,
      } = data;
      const obj = [
        [
          { title: this.$t("city"), value: city },
          { title: this.$t("area"), value: area },
          { title: this.$t("cluster"), value: clusterValue },
          { title: this.$t("rsm"), value: rsmValue },
          { title: this.$t("tdm"), value: tdmValue },
          { title: this.$t("kae"), value: kaeValue },
        ],
      ];

      const secondRow = [
        { title: this.$t("outletType"), value: outletTypeValue },
        { title: this.$t("externalFormat"), value: externalFormatValue },
        { title: this.$t("channel"), value: channelValue },
        { title: this.$t("nARKA"), value: narkaValue },
        { title: this.$t("sipChannel"), value: sipChannelValue },
      ];
      const thirdRow = [];
      // Под «агентскими» ролями из-за экономии места в гриде поле «Внешний код» убирается. Это позволит сохранить кол-во полей без изменения (3 ряда, 6 колонок)
      if (!this.checkAccessItem("agencyTerritory-row")) {
        secondRow.push({ title: this.$t("externalCode"), value: externalCode });
        thirdRow.push({
          title: this.$t("territoryCluster"),
          value: territoryCluster,
        });
      } else {
        secondRow.push({
          title: this.$t("territoryCluster"),
          value: territoryCluster,
        });
      }

      thirdRow.push({ title: this.$t("tariffZone"), value: tariffZone });
      thirdRow.push({ title: this.$t("skyline"), value: skyline });
      if (this.checkAccessItem("agencyValue-row"))
        thirdRow.push({ title: this.$t("agency"), value: agencyValue });
      thirdRow.push({ title: this.$t("kAS"), value: kasValue });
      if (this.checkAccessItem("agencyTerritory-row")) {
        thirdRow.push({ title: this.$t("routeCode"), value: routeCodeValue });
        thirdRow.push({
          title: this.$t("merchandiser"),
          value: merchandiserValue,
        });
      }
      thirdRow.push({
        title: this.$t("coverage"),
        value: coverage ? this.$t("yes") : this.$t("no"),
      });
      obj.push(secondRow);
      obj.push(thirdRow);

      return obj;
    },
    getKpiColumns(data) {
      const {
        frequencyPlan,
        frequencyFact,
        timingPerVisitPlan,
        timingPerVisitFact,
        ratePerHourPlan,
        ratePerHourFact,
        osaPlan,
        osaFact,
        pssPlan,
        pssFact,
        tacticalTaskPlan,
        tacticalTaskFact,
        fteMerchPlan,
        fteMerchFact,
        totalSumPlan,
        totalSumFact,
        deltaISAOSAPlan,
        deltaISAOSAFact,
      } = data;
      const addPercent = (string) => {
        if (string === 0) return "0";
        return string ? `${string}%` : "";
      };
      const getPercentNumber = (value) =>
        (this.isGroupingGrid && !this.isGroupingOutletsMode) || value
          ? Number(parseFloat(value * 100).toFixed(2))
          : value;
      const obj = [
        [
          {
            title: this.$t("addressProgramOrderFrequency"),
            value: formatDigit(frequencyPlan, null, 0),
            fact:
              frequencyFact === 0 ? "0" : formatDigit(frequencyFact, null, 0),
          },
          {
            title: this.$t("timingPerVisit"),
            value: formatDigit(timingPerVisitPlan),
            fact: formatDigit(timingPerVisitFact),
          },
          {
            title: this.$t("ratePerHour"),
            value: formatDigit(ratePerHourPlan),
            fact: formatDigit(ratePerHourFact),
          },
        ],
        [
          {
            title: this.$t("osa"),
            value: addPercent(formatDigit(getPercentNumber(osaPlan))),
            fact: addPercent(formatDigit(getPercentNumber(osaFact))),
          },
          {
            title: this.$t("isaOsa"),
            value: addPercent(formatDigit(getPercentNumber(deltaISAOSAPlan))),
            fact: addPercent(formatDigit(getPercentNumber(deltaISAOSAFact))),
          },
          {
            title: this.$t("pss"),
            value: addPercent(formatDigit(getPercentNumber(pssPlan))),
            fact: addPercent(formatDigit(getPercentNumber(pssFact))),
          },
        ],
        [
          {
            title: this.$t("tacticalTask"),
            value: formatDigit(tacticalTaskPlan),
            fact: formatDigit(tacticalTaskFact),
          },
          {
            title: this.$t("fteMerch"),
            value: formatDigit(fteMerchPlan),
            fact: formatDigit(fteMerchFact),
          },
          {
            title: this.$t("totalSum"),
            value: this.formatDigit(totalSumPlan),
            fact: this.formatDigit(totalSumFact),
          },
        ],
      ];
      return obj;
    },
    getGroupingParams(data) {
      const {
        rsmValue,
        tdmValue,
        kaeValue,
        outletTypeValue,
        externalFormatValue,
        channelValue,
        narkaValue,
        sipChannelValue,
        clusterValue,
        agencyValue,
        networkValue,
        kasValue,
      } = data;
      const obj = [
        [
          {
            title: this.$t("rsm"),
            value: rsmValue,
            isHidden: !this.selectedGroups.includes("RSMId"),
          },
          {
            title: this.$t("tdm"),
            value: tdmValue,
            isHidden: !this.selectedGroups.includes("TDMId"),
          },
          {
            title: this.$t("kae"),
            value: kaeValue,
            isHidden: !this.selectedGroups.includes("KAEId"),
          },
        ],
        [
          {
            title: this.$t("storeType"),
            value: outletTypeValue,
            isHidden: !this.selectedGroups.includes("OutletTypeId"),
          },
          {
            title: this.$t("externalFormat"),
            value: externalFormatValue,
            isHidden: !this.selectedGroups.includes("ExternalFormatId"),
          },
          {
            title: this.$t("channel"),
            value: channelValue,
            isHidden: !this.selectedGroups.includes("ChannelId"),
          },
          {
            title: this.$t("narka"),
            value: narkaValue,
            isHidden: !this.selectedGroups.includes("NARKAId"),
          },
          {
            title: this.$t("sipChannel"),
            value: sipChannelValue,
            isHidden: !this.selectedGroups.includes("SIPChannelId"),
          },
        ],
        [
          {
            title: this.$t("geoClusterShort"),
            value: clusterValue,
            isHidden: !this.selectedGroups.includes("ClusterId"),
          },
          {
            title: this.$t("agency"),
            value: agencyValue,
            isHidden: !this.selectedGroups.includes("AgencyId"),
          },
          {
            title: this.$t("network"),
            value: networkValue,
            isHidden: !this.selectedGroups.includes("NetworkId"),
          },
          {
            title: this.$t("addressProgramOrderKasValue"),
            value: kasValue,
            isHidden: !this.selectedGroups.includes("KASValue"),
          },
        ],
      ];
      return obj;
    },
    closeHistory() {
      this.showHistoryModal = false;
    },
    showHistory(record) {
      this.$refs.history.tabs[0].masterId = record.id;
      this.$refs.history.masterName = record.code;
      this.$nextTick(() => {
        this.showHistoryModal = true;
      });
    },
    toItem(data) {
      if (!this.isGroupingGrid || this.isGroupingOutletsMode) {
        if (this.isUserHasAgency && this.currentPeriod.status === "closed") {
          return;
        }
        let groupingState = {
          selectedGroups: this.selectedGroups,
          isGroupingOutletsMode: this.isGroupingOutletsMode,
          selectedModel: data,
          oldFilters: this.oldFilters,
        };
        this.$router.push({
          path: `/addressprogramarchived/addressprogramorder/${data.id}`,
          query: {
            groupingState: JSON.stringify(groupingState),
          },
        });
      } else {
        if (this.gridSelectionMode === "multiple") {
          data = this.grid.getSelectedModel();
        }
        const params = this.$route.params;
        if (!params.groupingState) {
          this.oldFilters = _.cloneDeep(this.filterPanel.filter);
        }
        this.selectedGroups.forEach((group) => {
          Object.entries(data).forEach(([key, value]) => {
            if (key.toLowerCase() === group.toLowerCase()) {
              this.filterPanel.filter[group] = {
                and: [value],
              };
            }
          });
        });
        this.addressProgramOrderService.setGroups([]);
        this.filterPanel.submitFilter(false, false);
        this.$refs.groupingPanel.collapsePanel();
        this.isGroupingOutletsMode = true;
        this.selectedModel = null;
      }
    },
    submitFilter({ filter, search }) {
      if (Object.keys(this.currentPeriod).length > 0) {
        this.grid.resetSkip();
        this.grid.submitFilter(filter, search);
        this.addressProgramFilter = this.grid.getRecords(true, true);
        this.getSummary(filter, search);
      }
      this.loadingHandler(true);
    },
    emitFilter() {
      const filter = this.$refs["customFilterRef"];
      if (filter) {
        filter.apply();
      }
      //this.filterPanel.submitFilter();
    },
    handlerClickCheckboxFilter(model, filter) {
      if (this.selectedCount > 0) {
        this.showClearModal = true;
        this.actionClear = () => {
          this.selectedMultipleClear();
          this.customFilterApply(filter, model, true);
          this.showClearModal = false;
        };
        this.actionCancelClear = () => {
          this.$refs["filter-checkbox"].onCheckboxClicked();
          this.showClearModal = false;
        };
      } else {
        this.customFilterApply(filter, model, true);
      }
    },
    customFilterApply(
      filter,
      model,
      needSaveToLocalStorage = false,
      multiselect = false
    ) {
      filter = Object.assign(filter, model);
      this.filterPanel.submitFilter(true, needSaveToLocalStorage);
      if (multiselect) {
        this.$refs.filterCoverage.close();
      }
    },
    async actionUpdate() {
      this.selectedCount = 0;
      this.loadingHandler(true);
      this.initHandler();
      // this.grid.getRecords(true);
      if (this.$refs["right-panel"]) {
        await this.$refs["right-panel"].update();
      }
      this.grid.resetSkip();
    },
    actionPeriod() {
      this.$store.commit("marsPeriodStoreArchived/SET_PERIODMODALSTATE", true);
    },
    actionImport() {
      this.showImportModal = true;
    },
    actionCopy() {
      let me = this;
      me.isDataCopying = true;
      me.addressProgramOrderService
        .copyAgencyTerritory(me.currentPeriod.id)
        .then(() => {
          me.isDataCopying = false;
          me.actionUpdate();
        });
    },
    actionPublish() {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.publish(me.currentPeriod.id).then(() => {
        me.actionUpdate();
      });
      me.canPublish = false;
    },
    actionApprove() {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.approve(me.currentPeriod.id).then(() => {
        me.actionUpdate();
      });
      me.order.canApprove = false;
    },
    actionConfirm() {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.confirm(me.currentPeriod.id).then(() => {
        me.actionUpdate();
      });
      me.order.canConfirm = false;
    },
    loadingHandler(val) {
      this.grid ? (this.grid.loading = val) : "";
    },
    selectedHandler(val) {
      /*if (this.isGroupingGrid && items[0].length === 0) {
        items = []
      }*/
      this.checkIsAllRowsSelected();
      this.selectedMultipleGridHandler(val);
    },
    showChangeModal() {
      this.isEdit = false;
      this.isCreate = true;
      this.modalModel = {};
      this.showModal = true;
    },
    openItem(model) {
      if (!model) return;
      this.addressProgramOrderService.delete(model).then(() => {
        this.actionUpdate();
        this.selectedModel = null;
      });
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      let text = "";
      switch (status) {
        case "plan":
          type = "light-blue";
          text = this.$t("planStatus");
          break;
        case "draft":
          type = "draft";
          text = this.$t("draftStatus");
          break;
        case "planfact":
          type = "teal";
          text = this.$t("planFactStatus");
          break;
      }
      return {
        text,
        type,
      };
    },
    dotsWrapper(item) {
      return item.orderStatus === "completed"
        ? this.dotsOptions.filter((x) => x.name !== "adjustmentRequest")
        : this.dotsOptions;
    },
    handleDots(action, item) {
      var option = this.dotsOptions.find((o) => o.name === action);
      if (action === "adjustmentRequest") {
        option.method(item, true);
      } else {
        option.method(item);
      }
    },
    adjustmentRequestHandler(data, fromRow = false) {
      if (this.currentPeriod?.isBlocked) {
        this.showBlockAdjustmentsModal = true;
        return;
      }
      let me = this;
      let path = "/addressprogramarchived/addressprogramorder/";
      const isMulti =
        (me.selectedCount > 1 || typeof me.selectedCount === "string") &&
        !fromRow;
      path += !isMulti ? data?.id : "adjustmentmultiplecreate";
      const requestModel = this.getRequestModel();
      let adjustmentSettings = {
        //при наличии фильтра - исключения, при отсутсвии фильтра - список точек для корректировки
        records: requestModel.records,
        //фильтр (если выбрано всё исключения передаются в records)
        filter: requestModel.filter,
        // filterObject: me.$refs.grid.filter,
        groupCounter: isMulti
          ? me.selectedClude?.isAll
            ? me.summary.outletCount - me.selectedClude.items?.length
            : me.selectedCount
          : null,
      };
      //формирование объекта фильтра для отображения списка точек на форме подачи корректировки
      //выбраны все записи с исключениями
      if (
        isMulti &&
        me.selectedClude?.isAll &&
        me.selectedClude.items?.length > 0
      ) {
        adjustmentSettings.filterObject = Object.assign(
          {
            id: {
              or: me.selectedClude.items.map((x) => {
                return { ne: x.id };
              }),
            },
          },
          me.$refs.grid.filter
        );
        //Выбран список записей
      } else if (
        isMulti &&
        !me.selectedClude?.isAll &&
        me.selectedClude?.items?.length > 0
      ) {
        adjustmentSettings.filterObject = {
          id: { or: me.selectedClude.items.map((x) => x.id) },
        };
        //выбраны все записи
      } else if (
        isMulti &&
        me.selectedClude?.isAll &&
        me.selectedClude.items?.length === 0
      ) {
        adjustmentSettings.filterObject = me.$refs.grid.filter;
      }

      let groupingState = null;
      if (me.isGroupingGrid) {
        groupingState = {
          selectedGroups: me.selectedGroups,
          isGroupingOutletsMode: me.isGroupingOutletsMode,
          selectedModel: data,
          oldFilters: me.oldFilters,
        };
      }
      let settingsCode = btoa(`apa-settings-${this.userinfo.id}`);

      let params = {
        adjustmentSettings: adjustmentSettings,
        groupingState: groupingState,
      };
      localStorage.setItem(settingsCode, JSON.stringify(params));
      me.$router.push({
        path,
        query: {
          settingsCode,
        },
      });
    },
    tryGetAgency(data) {
      if (Array.isArray(data)) {
        let uniqueAgencies = [...new Set(data?.map((x) => x.agencyId))];
        if (uniqueAgencies.length === 1)
          return [data[0].agencyId, data[0].agencyValue];
      }

      return [null, null];
    },
    // get header title
    // if Agency user - agency name otherwise "Mars"
    getTitle() {
      let me = this;
      if (
        me.checkAccessItem("grid-headertag-orderStatus") &&
        me.userinfo.agencyLinkType == "AGENCY"
      ) {
        return (
          me.userinfo.agencyLinkAgencyValue +
          " | " +
          me.$t("addressProgramOrders")
        );
      } else if (this.isGroupingOutletsMode) {
        return `${me.$t("addressProgramOrders")} (${me
          .$t("group")
          .toLowerCase()})`;
      } else {
        return `${me.$t("mars")} | ${me.$t("addressProgramOrders")}`;
      }
    },
    checkApprove() {
      return (
        this.checkAccessItem("grid-headerButton-approve") &&
        this.order?.canApprove
      );
    },
    checkConfirm() {
      return (
        this.checkAccessItem("grid-headerButton-confirm") &&
        this.order?.canConfirm
      );
    },
    checkOrderStatusTag() {
      if (this.order) {
        switch (this.order.status) {
          case "published":
            this.statusTagType = "purple";
            break;
          case "approved":
            this.statusTagType = "blue-main";
            break;
          case "completed":
            this.statusTagType = "teal";
            break;
          case "created":
            this.statusTagType = "plan";
            break;
          default:
            this.statusTagType = "default";
        }
      }
      return (
        this.checkAccessItem("grid-headertag-orderStatus") &&
        this.userinfo.agencyLinkType == "AGENCY" &&
        this.order
      );
    },
    checkOpenPeriod() {
      return this.checkAccessItem("grid-headerButton-openPeriod");
    },

    // if agency user
    // load current period published order for user agency only
    loadOrder() {
      if (this.userinfo.agencyLinkType == "AGENCY") {
        return this.orderService.get(this.currentPeriod.id);
      } else {
        this.checkPublish();
        return new Promise(() => {});
      }
    },
    checkPublish() {
      if (this.checkAccessItem("request-checkPublish")) {
        this.orderService.checkPublish(this.currentPeriod.id).then((res) => {
          this.canPublish = res.data?.data?.canPublish;
          this.canClose = res.data?.data?.canClose;
        });
      } else {
        this.canPublish = false;
        this.canClose = false;
      }
    },
    buildSimpleFilter(filter) {
      // convert filter like { field: "field", value: 1 } to query string
      const itemFilter = (field, value) => `(((${field} eq ${value})))`;
      const joinedFilter = (arr) =>
        `$filter=(${[...arr]})`.split(",").join(" and ");
      const filters = (arr) =>
        arr.map((o) => {
          return itemFilter(o.field, o.value);
        });
      return joinedFilter(filters(filter));
    },
    getFilters(filter, search, customFilter) {
      // simplified mainGrid-method getRecords
      const me = this;
      let localFilter = [];
      let copyFilter = _.cloneDeep(filter);

      Object.keys(copyFilter).forEach((fK) => {
        let res = {};
        let fValue = copyFilter[fK];
        if (!fValue) return;

        Object.keys(fValue).forEach((fCond) => {
          if (Array.isArray(fValue[fCond])) {
            res[fCond] = fValue[fCond].map((filterOption) => {
              return { [fK]: filterOption };
            });
          } else {
            res[fCond] = fValue[fCond];
          }
        });
        localFilter.push(res);
      });

      if (search && Object.keys(search).length > 0) {
        localFilter.push(search);
      }

      let resFilter = {};
      if (customFilter) {
        resFilter = customFilter;
      } else {
        resFilter = {
          and: localFilter,
        };
      }

      let queryFilter = _.clone(
        me.queryBuilder({
          filter: resFilter,
        })
      );

      return queryFilter;
    },
    getSummary(filter, search, customFilter) {
      const me = this;
      let fastFilters, submittedFilter, queryFilter;

      fastFilters = this.buildSimpleFilter(this.modelFastFilter.value);
      if (filter || customFilter || search) {
        submittedFilter = this.getFilters(filter, search, customFilter);
      }
      queryFilter = submittedFilter
        ? "$filter=" + submittedFilter.split("$filter=").join("")
        : "";
      if (queryFilter) {
        this.addressProgramOrderServiceSummary.setGroups(["marsPeriodId"]);
        this.addressProgramOrderServiceSummary["grid"](queryFilter).then(
          (response) => {
            if (response?.data?.records?.length === 0) {
              this.summary = null;
            } else {
              const { outletCount, totalSumPlan } = response.data.records[0];
              this.summary = { outletCount, totalSumPlan };
            }
          }
        );
      }
    },
    bindResizeObserver() {
      const el = this.$refs["address-program"].$el;
      this.ro = new ResizeObserver(this.handlerResize).observe(el);
    },
    unbindResizeObserver() {
      if (!this.ro) {
        return;
      }
      const el = this.$refs["address-program"].$el;
      this.ro.unobserve(el);
    },
    handlerResize() {
      if (!this.$refs["address-program"]) {
        return;
      }
      const el = this.$refs["address-program"].$el;
      this.breakpoint = el.offsetWidth;
    },
    getFilterString() {
      return this.addressProgramFilter.split("&$top")[0];
    },
    agencyTerritoryEdit(newValues) {
      const model = {
        kasValue: newValues.kasValue,
        merchandiserValue: newValues.merchandiserValue,
        routeCodeValue: newValues.routeCodeValue,
        ...this.getRequestModel(),
      };
      this.isTerritoryEditLoading = true;
      this.addressProgramOrderService
        .updateMultipleAddressProgramOrderAgency(model)
        .then(() => {
          this.isTerritoryEditLoading = false;
          this.actionUpdate();
        });
    },
    showAgencyTerritoryModalHandler(data) {
      if (this.selectedClude) {
        this.selectedForTerritoryEdit = this.selectedClude.isAll
          ? this.gridData
          : this.selectedClude.items;
      } else {
        this.selectedForTerritoryEdit = [data];
      }
      this.showAgencyTerritoryModal = true;
    },
    handleHeaderDots(action) {
      switch (action) {
        case "export_xlsx":
          this.actionExport("XLSX");
          break;
      }
    },
    actionExport(format) {
      this.loadingHandler(true);
      this.addressProgramOrderService
        .export(this.grid.getRecords(false, true), format)
        .then(() => this.loadingHandler(false));
      //TODO: Catch error?
      //TODO: Show message(export task created)
    },
    showAlertConfirmOrder(modal) {
      this.confirmationOrdersModalState = { ...modal, show: true };
    },
    confirmationOrdersModalAction(action) {
      this[action]();
    },
    setTotalRecords(total) {
      const count = total || this.grid?.totalRecords;
      if (this.selectedCount && isNaN(this.selectedCount)) {
        const excluded = this.selectedClude?.items?.length;
        if (excluded) {
          this.totalRecords = count - excluded;
        } else {
          this.totalRecords = count;
        }
      } else {
        this.totalRecords = count;
      }
    },
    checkAllAccess() {
      const me = this;
      this.accessList.forEach((el) => {
        el.value = me.checkAccess(el.name);
      });
    },
    checkAccessItem(name) {
      const o = this.accessList.find((item) => item.name === name);
      return o?.value;
    },
    checkPeriod() {
      if (_.isEmpty(this.currentPeriod)) {
        this.actionPeriod();
      }
    },
  },
  created() {
    this.handlerRouteParams();
  },
  mounted() {
    this.checkAllAccess();
    const params = this.$route.params;
    if (params.status) {
      this.paramsFilters.status = params.status;
    }
    if (params.groupingState) {
      const groupingState = JSON.parse(params.groupingState);
      if (groupingState.isGroupingOutletsMode) {
        this.selectedModel = groupingState.selectedModel;
        this.addressProgramOrderService.setGroups(groupingState.selectedGroups);
        this.selectedGroups = groupingState.selectedGroups;
        this.oldFilters = groupingState.oldFilters;
        this.toItem(groupingState.selectedModel);
        params.groupingState = null;
      }
    }

    if (
      !this.filterPanel?.filter.coverage ||
      this.filterPanel?.filter.coverage?.or?.length === 0
    ) {
      this.filterPanel.filter.coverage = {
        or: [true],
      };
    }
    // если переход с дашборда, переопределяем фильтр покрытия всегда на true
    if (params.coverage) {
      this.filterPanel.filter.coverage = {
        or: [true],
      };
    }
    this.$nextTick(() => {
      this.loadingHandler(true);
    });
    // this.bindResizeObserver();
    if (Object.keys(this.filterPanel?.filter).length === 0) {
      //В случае очистки кэша нужно вызывать метод для создания фильтров
      this.filterPanel.submitFilter(true);
    } else if (this.$route.params.status) {
      this.orderStatus = null;
    } else if (this.$route.params.orderStatus) {
      this.$refs["customFilterRef"].clear();
    } else {
      this.orderStatus = this.filterPanel?.filter?.orderStatus?.and[0];
    }

    this.checkPeriod();
  },
};
</script>
<style lang="scss">
.address-program {
  grid-template-rows: max-content calc(100% - 90px) max-content !important;
  .prospace-left-panel {
    border-bottom: none;
  }
  th.address-program__column-store {
    .p-column-resizer {
      right: 0 !important;
    }
  }
  td.address-program__column-store {
    padding: 10px 0 !important;
    .address-program__column-store-container {
      height: 100%;
      border-right: 1px dashed var(--prospace-ui-border-color);
    }
  }

  th.address-program__bordered-column {
    .p-column-title {
      padding-left: 10px !important;
    }
    .p-column-resizer {
      right: 0 !important;
    }
  }
  td.address-program__bordered-column {
    border-right: 1px dashed var(--prospace-ui-border-color) !important;
    padding-right: 0 !important;
    &.no-right {
      border-right: none !important;
    }
  }

  th.address-program__column-store-amount {
    .p-column-title {
      padding-left: 10px !important;
    }
  }
  td.address-program__column-store-amount {
    display: flex !important;
    justify-content: center;
    &.frozen {
      border-left: 1px dashed var(--prospace-ui-border-color) !important;
    }
  }
  .column-start {
    align-items: flex-start !important;
  }

  .address-program__dropdown .p-dropdown {
    background: none;
    border: none;
    height: auto;
  }
  .address-program__dropdown .prospace-dropdown-panel {
    width: 178px;
    position: absolute !important;
    right: 0 !important;
    left: auto !important;
    top: 24px !important;
    border: var(--prospace-ui-border);
  }
  .address-program__dropdown
    .p-dropdown-panel
    .p-dropdown-items
    .p-dropdown-item {
    padding: 7.5px 10px;
  }
  .address-program__dropdown
    .p-dropdown-panel
    .p-dropdown-items
    .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus,
  .address-program__dropdown
    .p-dropdown-panel
    .p-dropdown-items
    .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
    background-color: var(--prospace-ui-row-select);
  }
  &__dropdown {
    position: absolute;
    width: auto !important;
    order: 3;
    top: -2px;
    right: 0;
    max-width: 20px;
    max-height: 20px;
    .p-dropdown-trigger {
      width: auto;
      margin-left: auto;
    }
  }
}
</style>
